import getApiInstance from '@/api';
import type { CustomerProfileParametersDTO } from '@/types/dto/agent';
import { useEffect, useState } from 'react';

type PasswordComplexity = Pick<
  CustomerProfileParametersDTO,
  'passwordComplexityRegexLocalization' | 'passwordComplexityRegex'
>;

const usePasswordComplexity = () => {
  const [passwordComplexity, setPasswordComplexity] = useState<{
    regex: PasswordComplexity['passwordComplexityRegex'];
    regexLocalization: PasswordComplexity['passwordComplexityRegexLocalization'];
  } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getPasswordRequirements() {
      const api = (await getApiInstance()).agentApi;
      const { passwordComplexityRegexLocalization, passwordComplexityRegex } = (
        await api.CustomerProfilesConfiguration_GetCustomerProfilesParameters()
      ).data;

      setPasswordComplexity({
        regexLocalization: passwordComplexityRegexLocalization,
        regex: passwordComplexityRegex,
      });
      setLoading(false);
    }

    getPasswordRequirements();
  }, []);

  return { passwordComplexity, loading };
};

export default usePasswordComplexity;
